/* tslint:disable */
/* eslint-disable */
/**
 * Example API
 * API description
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface CreatePostRequest
 */
export interface CreatePostRequest {
    /**
     * Text content of the post (optional if imageUrl or fileId is provided)
     * @type {string}
     * @memberof CreatePostRequest
     */
    text?: string;
    /**
     * URL of the post image (optional if text or fileId is provided)
     * @type {string}
     * @memberof CreatePostRequest
     */
    imageUrl?: string;
    /**
     * ID of an already uploaded file (optional if text or imageUrl is provided)
     * @type {string}
     * @memberof CreatePostRequest
     */
    fileId?: string;
    /**
     * Type of entity this post is about
     * @type {string}
     * @memberof CreatePostRequest
     */
    postableType: CreatePostRequestPostableTypeEnum;
    /**
     * ID of the entity this post is about
     * @type {string}
     * @memberof CreatePostRequest
     */
    postableId: string;
}


/**
 * @export
 */
export const CreatePostRequestPostableTypeEnum = {
    Itinerary: 'itinerary',
    Stop: 'stop'
} as const;
export type CreatePostRequestPostableTypeEnum = typeof CreatePostRequestPostableTypeEnum[keyof typeof CreatePostRequestPostableTypeEnum];


/**
 * Check if a given object implements the CreatePostRequest interface.
 */
export function instanceOfCreatePostRequest(value: object): value is CreatePostRequest {
    if (!('postableType' in value) || value['postableType'] === undefined) return false;
    if (!('postableId' in value) || value['postableId'] === undefined) return false;
    return true;
}

export function CreatePostRequestFromJSON(json: any): CreatePostRequest {
    return CreatePostRequestFromJSONTyped(json, false);
}

export function CreatePostRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): CreatePostRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'text': json['text'] == null ? undefined : json['text'],
        'imageUrl': json['imageUrl'] == null ? undefined : json['imageUrl'],
        'fileId': json['fileId'] == null ? undefined : json['fileId'],
        'postableType': json['postableType'],
        'postableId': json['postableId'],
    };
}

  export function CreatePostRequestToJSON(json: any): CreatePostRequest {
      return CreatePostRequestToJSONTyped(json, false);
  }

  export function CreatePostRequestToJSONTyped(value?: CreatePostRequest | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'text': value['text'],
        'imageUrl': value['imageUrl'],
        'fileId': value['fileId'],
        'postableType': value['postableType'],
        'postableId': value['postableId'],
    };
}

